import { render, staticRenderFns } from "./transMC.vue?vue&type=template&id=6843ebc1"
import script from "./transMC.vue?vue&type=script&lang=js"
export * from "./transMC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports